
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/child-protective-services",
      function () {
        return require("private-next-pages/practice-areas/child-protective-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/child-protective-services"])
      });
    }
  